import "rxjs/add/operator/map";
import { of } from "rxjs/observable/of";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import type { IStore } from "reducers";
import { INSIGHTS } from "constants/action-types";
import { ColorInsights } from "models/insights/color-insights";
import { stringify } from "querystring";

export const fetchProductColorInsightsEpic = (action$, store) =>
    action$.ofType(INSIGHTS.FETCH_PRODUCT_COLOR_INSIGHTS.START).switchMap(({ payload }) => {
        const state: IStore = store.getState();
        const brandId = state.scope.brand._id;

        const query = {
            viewAsCompanyId: payload.viewAsCompanyId,
        };

        let url = "";

        if (payload.viewAsCompanyId) {
            url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/colors?${stringify(query)}`;
        } else {
            url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/colors`;
        }

        return ajax({
            url,
            method: "GET",
            withCredentials: true,
            crossDomain: true,
            headers: {
                "Content-Type": "application/json",
            },
            handle401: false,
        })
            .map(({ response, status }) => {
                if (status !== 200) {
                    throw new Error(response.message || "Unknown fetch error");
                }
                return {
                    type: INSIGHTS.FETCH_PRODUCT_COLOR_INSIGHTS.COMPLETED,
                    productColors: mapResponseToProductColors(response),
                };
            })
            .catch((error) =>
                of({
                    type: INSIGHTS.FETCH_PRODUCT_COLOR_INSIGHTS.ERROR,
                    error: `Failed to fetch category insights: ${error.message}`,
                })
            );
    });

const mapResponseToProductColors = (responseData) => {
    const productColors = [];

    if (Array.isArray(responseData.colors)) {
        responseData.colors.forEach((data) => {
            productColors.push(new ColorInsights(data));
        });
    }
    return productColors;
};
